(function () {
    'use strict';

    angular.module('app')
        .directive('customSelect', function() {
            return {
                templateUrl: 'components/directives/custom_select/view.custom_select.html',
                controller: 'CustomSelectController',
                controllerAs: 'CustomSelect',
                scope: {
                    'options': '=',
                    'config': '<?',
                    'selectedOptions': '='
                },
                bindToController: true
            }
        });
})();
